<script setup>
import { watch } from 'vue';
import { requiredIf } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import dayjs from 'dayjs';
import FormDateInput from '../../molecules/form/FormDateInput.vue';
import { customFieldProps } from '../../../utils/custom-fields';
import CustomFieldWrapper from './CustomFieldWrapper.vue';
import FormMessage from '../../atoms/form/FormMessage.vue';

const props = defineProps({ ...customFieldProps });
const model = defineModel({
    type: String,
});

const rules = {
    model: {
        required: requiredIf(() => props.required),
        valid: (dateString) => {
            if (!dateString) return true; // No value is not invalid
            return dayjs(dateString).isValid();
        },
    },
};

const v$ = useVuelidate(rules, { model }, { $registerAs: `custom-field-${props.id}` });

watch(model, v$.value.$touch);
</script>

<template>
    <CustomFieldWrapper
        :id="id"
        :error="v$.$error"
        :label="label"
        :required="required"
        class="flex flex-col gap-xs"
        data-qa="custom field date"
    >
        <FormDateInput
            v-model="model"
            divider="."
            :name="`custom-field-${id}`"
            show-day
        />
        <FormMessage
            v-if="v$.$error"
            type="error"
            data-qa="custom field date error message"
        >
            <template v-if="v$.model.required.$invalid">
                Bitte fülle dieses Feld aus.
            </template>
            <template v-else>
                Bitte gib ein gültiges Datum ein.
            </template>
        </FormMessage>
    </CustomFieldWrapper>
</template>
